import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guard';
import { LayoutComponent } from '../layout/layout.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CasinoComponent } from './dashboard/casino/casino.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { InPlayComponent } from './in-play/in-play.component';
import { MyBetListComponent } from './my-bet-list/my-bet-list.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { RulesComponent } from './rules/rules.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { CasinoDetailComponent } from './casino-detail/casino-detail.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';
import { OtherPagesComponent } from './other-pages/other-pages.component';

const routes: Routes = [
  {
    path: "dashboard",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "pages/:id",
        component: OtherPagesComponent,
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "sports/:sid",
        component: SportListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "casino",
        component: CasinoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "casino-detail/:id/:cgameId",
        component: CasinoDetailComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "profile",
        component: MyProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "force-change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "rules",
        component: RulesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "inplay",
        component: InPlayComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "my-bets",
        component: MyBetListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "mobile-menu",
        component: MobileMenuComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "market-analysis",
        component: MarketAnalysisComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: "multi-market",
      //   component: MultiMarketComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: "deposit",
        component: DepositWithdrawComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "withdraw",
        component: DepositWithdrawComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  // {
  //   path: "",
  //   loadChildren: () =>
  //     import("./msports/msports.module").then((m) => m.MsportsModule),
  //   canActivate: [AuthGuard],
  // },
  {
    path: "",
    loadChildren: () =>
      import("./sports/sports.module").then((m) => m.SportsModule),
    canActivate: [AuthGuard],
  },
  // {
  //   path: "casino",
  //   loadChildren: () =>
  //     import("./casino/casino.module").then((m) => m.CasinoModule),
  //     canActivate: [AuthGuard],
  // },
  // {
  //   path: "slot",
  //   loadChildren: () =>
  //     import("./slot/slot.module").then((m) => m.SlotModule),
  //     canActivate: [AuthGuard],
  // },
  // {
  //   path: "fantasy",
  //   loadChildren: () =>
  //     import("./fantasy-games/fantasy-games.module").then((m) => m.FantasyGamesModule),
  //     canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class PagesRoutingModule { }
